<script lang="ts">
  import { link } from "svelte-routing"
  import {
    Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Row, Col,
  } from "sveltestrap"
  import { connected, chainId, chainData, defaultEvmStores, selectedAccount, web3 } from "svelte-web3";
  import WalletConnect from "./WalletConnect.svelte";
  import { shortenAddress } from "../utils/utils"
  import { CONFIG } from "../config"

  let expanded = false;
  let searchExpanded = false;
  let searchValue = '';

  const search = e => {
    if (e.charCode === 13) {
      const nftId = Number.parseInt(searchValue);
      if (!isNaN(nftId)) {
        window.location.href = `/nft/${nftId}`
      }
    }
  }
</script>

<Row class="top-nav align-items-center align-content-center gx-0">
  <Col class="top-nav-logo" md="3">
    <a href="/" use:link>
      <img class="logo" src="/logo.svg"/>
    </a>
  </Col>
  <Col class="mobile-top-nav-logo" style={searchExpanded ? 'display: none' : ''}>
    <a href="/" use:link>
      <img class="logo" src="/logo.svg"/>
    </a>
  </Col>
  <Col class="search-bar-col" md="4">
    <div class="search-bar-box">
      <i class="ri-search-line ri-lg"></i>
      <Input class="search-bar" placeholder="Search a pair ID" on:keypress={search} bind:value={searchValue}/>
    </div>
  </Col>
  <Col class="top-nav-end mobile-menu" xs="5" style={searchExpanded ? 'display: none' : ''}>
    <i class="ri-search-line ri-lg" on:click={() => searchExpanded = !searchExpanded}></i>
  </Col>
  <Col class="top-nav-end mobile-menu" xs="10" style={searchExpanded ? '' : 'display: none'}>
    <div class="mobile-search-bar-box">
      <i class="ri-search-line ri-lg"></i>
      <Input class="search-bar" placeholder="Search a pair ID" on:keypress={search} bind:value={searchValue}/>
      <img class="icon-medium" src="/icons/close-line.svg" on:click={() => searchExpanded = !searchExpanded}/>
    </div>
  </Col>
  <Col class="top-nav-end mobile-menu mobile-menu-button" xs="1">
    <img class="icon-large" src={`/icons/${expanded ? 'close-line' : 'menu'}.svg`} on:click={() => expanded = !expanded}/>
  </Col>
  <div style={expanded ? '' : 'display: none'} class="filter-expand">
    <Row class="mobile-wallet-info gx-0">
      <Col>
        {#if $connected}
          <Row class="gx-0">
            <Col>
              <img class="mobile-wallet-symbol" src="/wallet.svg" alt="placeholder"/>
            </Col>
            <Col class="col-auto">
              <div class="mobile-network-badge">
                <img class="network-symbol" src="/icons/ethereum.svg">
                {CONFIG.hasOwnProperty($chainId) ? CONFIG[$chainId].name : 'Unsupported'}&nbsp;&nbsp;
              </div>
            </Col>
          </Row>
          <Row>
            <Col class="col-auto mobile-wallet-addr">
              {shortenAddress($selectedAccount)}
              <span class="mobile-copy-btn">
                <img class="icon-small" src="/icons/copy.svg" alt="placeholder"/>
              </span>
            </Col>
          </Row>
        {:else}
          <WalletConnect className="button-line mobile-wallet-connect">Connect to a wallet</WalletConnect>
        {/if}
        <Row class="mobile-wallet-info-grad"/>
      </Col>
    </Row>
    <Row class="mobile-nav-menu">
      <a class="mobile-nav-link" href="/portfolio/positions" use:link on:click={() => expanded = !expanded}>
        <Col>
          <img class="icon-medium" src="/icons/chart.svg" alt="placeholder">&nbsp;&nbsp;Portfolio
        </Col>
      </a>
    </Row>
    <Row class="mobile-nav-menu">
      <a class="mobile-nav-link" href="/staking" use:link on:click={() => expanded = !expanded}>
        <Col>
          <img class="icon-medium" src="/icons/staking.svg" alt="placeholder">&nbsp;&nbsp;Staking
        </Col>
      </a>
    </Row>
    <Row class="mobile-nav-menu">
      <a class="mobile-nav-link" href="/upload" use:link on:click={() => expanded = !expanded}>
        <Col>
          <img class="icon-medium" src="/icons/upload.svg" alt="placeholder">&nbsp;&nbsp;Upload
        </Col>
      </a>
    </Row>
    <Row class="mobile-nav-menu">
      <a href="https://docs.pilgrim.money/" target="_blank">
        <Col>
          <img class="icon-medium" src="/icons/plus.svg" alt="placeholder">&nbsp;&nbsp;Docs
        </Col>
      </a>
    </Row>
    <Row class="mobile-nav-menu">
      <a href="https://app.uniswap.org/#/swap?exactField=input&inputCurrency=ETH&outputCurrency=0x5bd46d83Ab0DB4427F89f01F9dD0A0b9Ab266148&chain=mainnet" target="_blank">
        <Col>
          <img class="icon-medium" src="/icons/plus.svg" alt="placeholder">&nbsp;&nbsp;Trade $PIL at Uniswap
        </Col>
      </a>
    </Row>

  </div>
  <Col class="col-auto top-nav-end" md="5">
    <Row clas="align-items-center">
      <Col class="col-auto align-self-center">
        <a class="top-nav-link" href="/staking" use:link>Staking</a>
      </Col>
      <Col class="col-auto align-self-center">
        <a class="top-nav-link" href="/upload" use:link>Upload</a>
      </Col>
      <Col class="col-auto align-self-center">
        <a class="top-nav-link" href="https://app.uniswap.org/#/swap?exactField=input&inputCurrency=ETH&outputCurrency=0x5bd46d83Ab0DB4427F89f01F9dD0A0b9Ab266148&chain=mainnet" target="_blank">Uniswap</a>
      </Col>

      <Col class="col-auto align-self-center">
        <Dropdown end>
          <DropdownToggle caret class="top-nav-link" >
            <img class="icon-small" src="/icons/plus.svg" alt="placeholder"/>
            More
          </DropdownToggle>
          <DropdownMenu>
            <a href="https://docs.pilgrim.money/" target="_blank">
              <DropdownItem>Docs</DropdownItem>
            </a>
            <a href="https://app.uniswap.org/#/swap?exactField=input&inputCurrency=ETH&outputCurrency=0x5bd46d83Ab0DB4427F89f01F9dD0A0b9Ab266148&chain=mainnet" target="_blank">
              <DropdownItem>Trade $PIL at Uniswap</DropdownItem>
            </a>

          </DropdownMenu>
        </Dropdown>
      </Col>
      <Col class="align-self-center">
        {#if $connected}
          <Row>
            <Col>
              <div class="network-badge">
                <img class="network-symbol" src="/icons/ethereum.svg">
                {CONFIG.hasOwnProperty($chainId) ? CONFIG[$chainId].NAME : 'Unsupported'}&nbsp;&nbsp;
<!--                <i class="ri-arrow-down-s-line icon-small"></i>-->
              </div>
            </Col>
            <Col class="wallet-drop-col">
              <Dropdown>
                <DropdownToggle caret class="top-nav-link wallet-toggle" >
                  <img class="wallet-symbol" src="/wallet.svg" alt="placeholder"/>
                </DropdownToggle>
                <DropdownMenu end class="wallet-drop-manu">
                  <DropdownItem class="wallet-drop-item wallet-drop-first">
                    {shortenAddress($selectedAccount)}
<!--                    <div class="copy-btn">-->
<!--                      <img class="icon-small" src="/icons/copy.svg" alt="placeholder"/>-->
<!--                    </div>-->
                  </DropdownItem>
                  <DropdownItem class="wallet-drop-item wallet-drop-last">
                    <a href="/portfolio/positions" use:link>
                      <img class="icon-small" src="/icons/chart.svg" alt="placeholder"/>
                      &nbsp;Portfolio
                    </a>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
        {:else}
          <WalletConnect className="button-line wallet-connect flex-row-reverse">Connect to a wallet</WalletConnect>
        {/if}
      </Col>
    </Row>

  </Col>
</Row>
